const userCenterView = () => import("@views/user-center-info/user-center-info-view.vue");

export const userCenterRoutes = [
    {
        component: userCenterView,
        name: "info_home",
        path: "info",
    },
];